import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_wishlist_products, remove_wishlist, add_to_card } from '../../store/reducers/cardReducer';
import { imgUrl } from '../../utils/imgUrl';
import { DISPLAY, priceLabel, Heart, Plus } from '../home/ui';
import { PageHead, EmptyCard, pbtn } from '../account/shared';

// Favoritos (diseño cuenta.html). Los avisos los muestra el layout.

const Wishlist = () => {
    const dispatch = useDispatch();
    const { userInfo } = useSelector(state => state.auth);
    const { wishlist } = useSelector(state => state.card);

    useEffect(() => { dispatch(get_wishlist_products(userInfo.id)); }, []);

    return (
        <section>
            <PageHead title='Favoritos' sub='Lo que guardaste para después.' />
            {wishlist.length === 0 ? (
                <EmptyCard icon={<Heart className='w-[26px] h-[26px]' />} title='Aún no tienes favoritos' text='Toca el corazón en cualquier producto para guardarlo aquí.'>
                    <Link to='/shops' className={pbtn}>Explorar la tienda</Link>
                </EmptyCard>
            ) : (
                <div className='grid grid-cols-3 lg:grid-cols-2 gap-4 sm:gap-[10px]'>
                    {wishlist.map(p => {
                        const detail = `/product/details/${p.slug}`;
                        return (
                            <article key={p._id} className='bg-white rounded-[18px] border-[1.5px] border-[#f1efea] p-3 flex flex-col gap-[10px] transition-all hover:-translate-y-1 hover:border-transparent hover:shadow-[0_6px_18px_-6px_rgba(15,23,42,.08)]'>
                                <div className='relative rounded-[14px] overflow-hidden bg-[#faf9f6]' style={{ aspectRatio: '1 / 1' }}>
                                    <Link to={detail} className='absolute inset-0'>
                                        {p.image
                                            ? <img src={imgUrl(p.image)} alt={p.name} className='w-full h-full object-cover' />
                                            : <span className='w-full h-full grid place-items-center text-[44px] opacity-30'>🐾</span>}
                                    </Link>
                                    <button type='button' onClick={() => dispatch(remove_wishlist(p._id))} aria-label={`Quitar ${p.name} de favoritos`}
                                        className='absolute top-2 right-2 w-[34px] h-[34px] rounded-full bg-[#f87171] text-white grid place-items-center shadow-[0_2px_6px_rgba(15,23,42,.12)] hover:scale-[1.08] transition-transform [&_path]:fill-current'>
                                        <Heart className='w-[15px] h-[15px]' />
                                    </button>
                                </div>
                                <Link to={detail}>
                                    <h4 className='text-[14px] font-bold text-[#0f172a] leading-[1.3] m-0 hover:text-[#0891b2]'
                                        style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: '36px' }}>{p.name}</h4>
                                </Link>
                                <span className={`${p.price > 0 ? 'text-[19px]' : 'text-[15px]'} font-extrabold text-[#1e3a8a] mt-auto`} style={DISPLAY}>{priceLabel(p.price)}</span>
                                <button type='button' onClick={() => dispatch(add_to_card({ userId: userInfo.id, quantity: 1, productId: p.productId }))}
                                    className='w-full bg-[#faf9f6] text-[#1e3a8a] font-bold text-[13px] px-3 py-[10px] rounded-[11px] inline-flex items-center justify-center gap-[6px] border-[1.5px] border-[#f1efea] hover:bg-[#1e3a8a] hover:text-white hover:border-[#1e3a8a] transition-all'>
                                    <Plus className='w-[14px] h-[14px]' />Agregar al carrito
                                </button>
                            </article>
                        );
                    })}
                </div>
            )}
        </section>
    );
};

export default Wishlist;
